module.exports = __webpack_public_path__ + "img/img-5.4cf0dd8d.png";